// this is an autogenerated file from DesignSystem/TasksCreateForm/Tags/Content/mutation-delete-tag.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_TasksCreateForm_Tags_Content($id: uuid!) {
  delete_tasks_tags_by_pk(id: $id) {
    id
  }
}

`